export default __webpack_public_path__ + "futsal-pre.png";